import { render, staticRenderFns } from "./ServiceForm.vue?vue&type=template&id=97195f70&scoped=true"
import script from "./ServiceForm.vue?vue&type=script&lang=js"
export * from "./ServiceForm.vue?vue&type=script&lang=js"
import style0 from "./ServiceForm.vue?vue&type=style&index=0&id=97195f70&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97195f70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97195f70')) {
      api.createRecord('97195f70', component.options)
    } else {
      api.reload('97195f70', component.options)
    }
    module.hot.accept("./ServiceForm.vue?vue&type=template&id=97195f70&scoped=true", function () {
      api.rerender('97195f70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/service/ServiceForm.vue"
export default component.exports